// @ts-nocheck
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, TemplateRef, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'lbca-overlay-modal',
	templateUrl: './modal.component.html',
	styleUrl: './modal.component.scss',
	imports: [CdkScrollable, NgTemplateOutlet],
	encapsulation: ViewEncapsulation.None,
})
export class ModalOverlayComponent {
	public template: TemplateRef<Object> | null = null;
	public properties: any = {};

	@Input()
	set templateRef(templateRef: TemplateRef<Object>) {
		this.template = templateRef;
	}

	@Input()
	set modalProperties(modalProperties: any) {
		this.properties = modalProperties;
	}
}
